type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  strokeColor?: string;
  strokeWidth?: string;
};

const MobilePhoneIcon = (props: Props) => {
  const {
    width = '16',
    height = '16',
    viewBox = '0 0 16 16',
    strokeColor = 'currentColor',
    strokeWidth = '1.5',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <rect
        x="4"
        y="1"
        width="8"
        height="14"
        rx="1"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
      />
      <path
        d="M7 13h2"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
    </svg>
  );
};

export default MobilePhoneIcon;
